export const formatPriceRange = (
  from: number | null,
  to: number | null
): string => {
  if (from == null && to == null) return '—';
  const format = (value: number) =>
    new Intl.NumberFormat('ru-RU').format(value);

  if (from != null && to != null) return `${format(from)} - ${format(to)}`;
  if (from != null) return `от ${format(from)}`;
  return `до ${format(to as number)}`;
};
